import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_LIFETALK_RADIO, TAGLINE } from "../../lib/siteConfig";

const links = [
  { to: "/", label: "Home" },
  { to: "/listen", label: "Radio Ministry" },
  { to: "/church", label: "Father's House Church" },
  { to: "/giving", label: "Giving" },
  { to: "/testimonies", label: "Testimonies" },
  { to: "/contact", label: "Contact Us" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#0B0C10]/90 backdrop-blur-xl border-b border-[#1F2833]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <span className="flex items-center justify-center w-12 h-12 bg-white overflow-hidden ring-1 ring-[#C5D1EB]/20">
            <img
              src={LOGO_LIFETALK_RADIO}
              alt="Life Talk Radio"
              className="w-12 h-12 object-contain"
              loading="eager"
            />
          </span>
          <span className="font-display leading-tight">
            <span className="block text-white text-[15px] font-semibold tracking-tight">
              Life Talk Trust
            </span>
            <span className="block text-[10px] uppercase tracking-[0.22em] text-[#C5D1EB]/70">
              {TAGLINE}
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => {
            const isListen = l.to === "/listen";
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `relative px-3 py-2 text-[13px] tracking-wide transition-colors inline-flex flex-col items-center ${
                    isActive ? "text-white" : "text-[#C5D1EB] hover:text-white"
                  }`
                }
              >
                <span>{l.label}</span>
                {isListen && (
                  <span
                    data-testid="nav-listen-live-pill"
                    className="mt-0.5 inline-flex items-center gap-1.5 text-[9px] uppercase tracking-[0.22em] text-[#FF3B30]"
                  >
                    <span
                      className="relative grid place-items-center w-2.5 h-2.5"
                      aria-hidden
                    >
                      <span className="col-start-1 row-start-1 w-2.5 h-2.5 rounded-full bg-[#FF3B30] opacity-75 animate-ping" />
                      <span className="col-start-1 row-start-1 w-1.5 h-1.5 rounded-full bg-[#FF3B30]" />
                    </span>
                    Listen Live
                  </span>
                )}
              </NavLink>
            );
          })}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-white"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#1F2833] bg-[#0B0C10]">
          <div className="px-5 py-4 flex flex-col gap-1">
            {links.map((l) => {
              const isListen = l.to === "/listen";
              return (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={({ isActive }) =>
                    `px-3 py-3 text-sm border-b border-[#1F2833] inline-flex items-center gap-2 ${
                      isActive ? "text-white" : "text-[#C5D1EB]"
                    }`
                  }
                >
                  {isListen && (
                    <span className="relative inline-flex w-2 h-2" aria-hidden>
                      <span className="absolute inset-0 rounded-full bg-[#FF3B30] opacity-75 animate-ping" />
                      <span className="relative inline-flex w-2 h-2 rounded-full bg-[#FF3B30]" />
                    </span>
                  )}
                  {l.label}
                </NavLink>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}
